import React, { useState } from 'react'
import AddGoal from './AddGoal'
import { useHistory } from 'react-router-dom'
import { useGetTeamGoals } from '../../../redux/human-resources/hook/performance'
import DataTable from '../../../components/datatable'
import { PAGINATION_DEFAULT } from '../../../utils/constants'

const TeamGoals = () => {
  const history = useHistory()
  const [goals, setGoals] = useState(false)
  const [pagination, setPagination] = useState({
    limit: PAGINATION_DEFAULT.limit,
    page: PAGINATION_DEFAULT.page,
    search: '',
  })

  const { data: employeeGoals } = useGetTeamGoals(
    pagination?.limit,
    pagination?.page,
    pagination?.search
  )

  const tableConfig = {
    headers: ['Goal Name', 'Start Date', 'Target Date'],
    keys: ['name', 'start_date', 'target_date'],
    mobileHeader: {
      left: {
        title: 'Goal Name',
        key: 'name',
      },
      right: {
        title: 'Start Date',
        key: 'start_date',
      },
    },
  }

  return (
    <>
      {goals ? (
        <AddGoal isOpen={goals} closeModal={() => setGoals(false)} type={0} />
      ) : null}

      <>
        <div className='flex mb-4'>
          <button
            onClick={() => setGoals(true)}
            className='bg-[#238B45] text-white rounded-md w-[160px] p-2'
          >
            Add New Goal
          </button>
        </div>
        <DataTable
          data={employeeGoals}
          tableConfig={tableConfig}
          updatePagination={(data) => setPagination(data)}
          tableType={'goals'}
          searchData={true}
        />
      </>
    </>
  )
}

export default TeamGoals
